import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_TAGS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/tags`;

export const ADMIN_TAGS_API_PATHS = {
  GET_TAGS: `${ADMIN_TAGS_API_ROOT}`,
  CREATE_TAG: `${ADMIN_TAGS_API_ROOT}`,
  UPDATE_TAG: (tagId: string) => `${ADMIN_TAGS_API_ROOT}/${tagId}`,
  DELETE_TAG: (tagId: string) => `${ADMIN_TAGS_API_ROOT}/${tagId}`,
};
